import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ProjectBuildingForm from './ProjectBuildingForm';
import { createProjectBuilding } from '../../../../actions/Construction/projectBuildingActions';
import { getProject } from '../../../../actions/Construction/projectActions';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import _ from 'lodash';

const ProjectBuildingCreate = (props) => {
	const project_id = props.match.params.project_id;

	const { datas, loading } = props;

	const onSubmit = (formValues) => {
		if (!_.isEmpty(formValues)) {
			props.createProjectBuilding(formValues);
		}
	};

	useEffect(() => {
		props.getProject(project_id);
	}, []);
	return (
		<>
			{loading ? (
				<LoadingSpinner />
			) : (
				<div className="mt-3">
					<ProjectBuildingForm onSubmit={onSubmit} datas={datas} />
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		finance: {
			project: { project, getProjectLoading },
		},
	} = state;

	return { datas: { project }, loading: getProjectLoading };
};

export default connect(mapStateToProps, { getProject, createProjectBuilding })(ProjectBuildingCreate);
